module.exports = __webpack_public_path__ + "assets/img/a9bacc1a4f2d4f3e300901df0efad27a.svg";